export default function (value) {
    if (!value) {
        return 'You need to check this value';
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./src/client/utils/isCheckedRadio.js